import { combineReducers } from 'redux'
import AmmunitionReducer from '@ClientReducers/ammunition.reducer'
import ContactReducer from '@ClientReducers/contact.reducer'
import FirearmAnomalyReducer from '@ClientReducers/firearm-anomaly.reducer'
import InspectionReducer from '@ClientReducers/inspection.reducer'
import MyAccountReducer from '@ClientReducers/my-account.reducer'
import AccessoriesReducer from './reducers/accessories.reducer'
import ClassificationReducer from './reducers/classification.reducer'
import FirearmReducer from './reducers/firearm.reducer'
import InsuranceReducer from './reducers/insurance.reducer'
import MyVaultReducer from './reducers/my-vault.reducer'
import ProfileReducer from './reducers/profile.reducer'
import RegroundReducer from './reducers/reground.reducer'
import SafeStorageReducer from './reducers/safe-storage.reducer'
import PartReducer from './reducers/parts.reducer'

const ClientReducers = combineReducers({
    firearms: FirearmReducer,
    accessories: AccessoriesReducer,
    parts: PartReducer,
    classifications: ClassificationReducer,
    regrounds: RegroundReducer,
    safeStorages: SafeStorageReducer,
    insurances: InsuranceReducer,
    profile: ProfileReducer,
    myAccount: MyAccountReducer,
    myVault: MyVaultReducer,
    firearmAnomaly: FirearmAnomalyReducer,
    ammunition: AmmunitionReducer,
    inspections: InspectionReducer,
    contacts: ContactReducer,
})

export default ClientReducers
export type RootState = ReturnType<typeof ClientReducers>
